import script from "./SiteBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteBadge.vue?vue&type=script&lang=ts&setup=true"

import "./SiteBadge.vue?vue&type=style&index=0&id=cc720fa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc720fa6"]])

export default __exports__